const catalogOrder = {
  'ISO27001:2013': 1,
  'ISO27002:2013': 2,
  'ISO27001:2022': 3,
  'ISO27002:2022': 4,
  'SOC2:2017': 5,
};

const criticalityMagnitude = {
  major: 0,
  minor: 1,
  info: 2,
};

const getSortId = (id, criticality) => {
  const catalogParts = id.split(':');
  if (catalogParts.length === 2) {
    return 0;
  }
  const parts = catalogParts.at(-1).split('.');
  const catalog = catalogParts.slice(0, 2).join(':');
  return catalogOrder[catalog] * 100000000
    + parseInt(parts.at(0).replace('A-', '')) * 10000000
    + parseInt(parts.at(1) || 0) * 10000
    + parseInt(parts.at(2) || 0) * 10
    + (criticalityMagnitude[criticality] ?? 0);
};

export const sorter = (a, b) => {
  const aId = a?.id ?? a.controlId;
  const bId = b?.id ?? b.controlId;
  return getSortId(aId, a.criticality) - getSortId(bId, b.criticality);
};

export const controlSorter = (a, b) => {
  const aId = a.controlId;
  const bId = b.controlId;
  return getSortId(aId, a.criticality) - getSortId(bId, b.criticality);
};
